import { render, staticRenderFns } from "./MPartnerList.vue?vue&type=template&id=1a1135a2&scoped=true&"
import script from "./MPartnerList.vue?vue&type=script&lang=js&"
export * from "./MPartnerList.vue?vue&type=script&lang=js&"
import style0 from "./MPartnerList.vue?vue&type=style&index=0&id=1a1135a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1135a2",
  null
  
)

export default component.exports